export default __webpack_public_path__ + "0295e18042733c6591cf35f5587cb945.svg";